import {
    CommandRegistry,
    type ContributionProvider,
    type Message,
} from '@patsnap/tahiti-core';
import { TypedCommandRegistry } from './typed-command';

const commandMessage: Message = {
    closeAll: () => undefined,
    success: () => undefined,
    warning: options => console.warn('[ApplicationCommand]', options.message),
    // eslint-disable-next-line no-console -- Message 接口的诊断通道，与相邻 warning/error 同构
    info: options => console.info('[ApplicationCommand]', options.message),
    error: options => console.error('[ApplicationCommand]', options.message),
};

const emptyContributions: ContributionProvider<object> = {
    getContributions: () => [],
};

/**
 * 创建应用级 Tahiti CommandRegistry。
 *
 * 每个 application composition root 拥有独立 registry，避免测试或多应用实例
 * 共享命令 owner。后续启用 Tahiti 内置 Inversify 6 时只需替换本装配点。
 */
export function createApplicationCommandRegistry(): TypedCommandRegistry {
    return new TypedCommandRegistry(
        new CommandRegistry(commandMessage, emptyContributions),
    );
}
